'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _style = require('../../style');

var keyframeShow = function keyframeShow() {
  return {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  };
};

var rule = function rule(_ref) {
  var background = _ref.background,
      color = _ref.color,
      text = _ref.text;
  return {
    padding: !text ? '7px' : '2px 4px',
    background: background || 'red',
    fontSize: '10px',
    borderRadius: '8px',
    color: color || '#ffffff',
    display: 'inline-block',
    position: 'relative',
    top: '-10px',
    left: '-6px',
    margin: '0 -0.5rem',
    zIndex: 10,
    animationDuration: '0.6s',
    animationName: _style.renderer.renderKeyframe(keyframeShow)
  };
};

var Badge = (0, _preactFela.createComponentWithProxy)(rule, 'span');

exports.default = function (props) {
  return (0, _preact.h)(
    Badge,
    props,
    props.children
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Badge.js
// module id = 62
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38